/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page2_Warning_ActionInputs */



/**
* | output |
* | --- |
* | "Actions in this document may change based on field diagnosis" |
*
* @param {Intervention_Plan_Pdf_Page2_Warning_ActionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page2_warning_action = /** @type {((inputs?: Intervention_Plan_Pdf_Page2_Warning_ActionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page2_Warning_ActionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Actions in this document may change based on field diagnosis")
	return /** @type {LocalizedString} */ ("Les actions à mener indiquées dans ce document sont susceptibles d'être modifiées en fonction du diagnostic terrain")
});